<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-02-14 16:52:36
 * @LastEditTime: 2020-03-15 10:55:32
 -->
<template>
  <!-- 外链的初始页面，用于分发到不同的页面 -->
  <component
    :is="curComponent"
    ref="common"
    :data="data"
  />
</template>

<script>
import extend from 'extend'
import _$ from 'js/api/getdata'
// import bsInvalid from 'components/business/approve/invalid/index.vue' // 外链失效页面
import bsLfile from 'components/business/approve/lfile/index.vue' // 文件外链的展示页面
import bsLfolder from 'components/business/approve/lfolder/index.vue' // 文件夹外链的展示页面
// import bsSmartshare from 'components/business/approve/smartshare/index.vue' // 文件夹外链的展示页面
// import bsPreLogin from 'components/business/preLogin/index.vue' // 文件夹外链的展示页面

export default {
  components: {
    // bsInvalid,
    bsLfile,
    bsLfolder,
    // bsSmartshare,
    // bsPreLogin,
  },
  data() {
    return {
      curComponent: '',
      data: {},
    }
  },
  created() {
    // 初始化
    this.init()
  },
  methods: {
    /**
             * 初始化外链
             *     '10001': 'bsInvalid',查不到外链信息
             *     '10002': 'bsInvalid',正在已经审核不允许通过
             *     '10003': 'bsInvalid',外链过期
             *     '10004': 'bsInvalid',审批被拒绝
             *     '10005': 'bsInvalid',发外链的账号已经过期
             *     '10006': 'bsInvalid',用户状态不正常
             *     '10007': 'bsInvalid',该外链没有开启外链功能
             *     '10008': '', 内链但没有登录
             *     '10009': '', 内链已经登录但当前用户和外链创建者不在同一企业
             *     '10000': '', 所有权限校验完成
             */
    async init() {
      const param = this.$route.params || {}
      const { taskId } = param
      const {
        fromNeid, fromNsid, handlers, action_type: actionType, serialNumber,
      } = this.$route.query // 查看带过来的数据
      const d = await _$.getData('approveInit', { task_id: taskId })
      const { data: { is_zip: isPkg } } = await _$.getData('isPkg', { snapshot_neid: fromNeid, snapshot_nsid: fromNsid })
      const params = {
        url: `/0/${serialNumber}`, // 0 外发，1 接收，同 type
        type: 0,
        serial_number: serialNumber,
      }
      // 请求外链信息并返回相应的状态
      // let d = await _$.getUrl(url)
      this.data = {
        handlers, // url带过来的参数
        action_type: actionType,
        neid: fromNeid,
        ...d.data,
      }
      if (actionType === '5') {
        let exchangeData = {}
        let approveData = {}
        try {
          exchangeData = (await _$.getData('ferryInit', params)).data
          approveData = (await _$.getData('queryApprovalTaskInfo', { task_id: taskId })).data
        } catch (error) {
          this.$emit('showTips', error.response.data.message, 'warn')
        }
        this.data = {
          ...this.data,
          isFerry: actionType === '5',
          ...exchangeData.data,
          approveData, // 此时 action_type 被覆盖为数字 5
        }
      }


      sessionStorage.setItem('rootName', d.data.apply_name)
      if (handlers === '0' && d.data.isApplier) {
        sessionStorage.setItem('character', 'applier')
        this.curComponent = 'bsLfolder'
      }
      // 审批者
      if (handlers === '1' && d.data.isApprover) {
        sessionStorage.setItem('character', 'approver')
        // 显示目录页面
        if (d.data.source === 'file' && !this.data.isFerry && !isPkg) {
          this.curComponent = 'bsLfile'
        } else {
          this.curComponent = 'bsLfolder'
        }
      }
    },
  },
}
</script>
